import { useState } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { BodyS } from '#src/atoms/typography/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';

import { BlockedUsersDialog } from './BlockedUsersDialog/index.tsx';

const StyledButtonBase = styled(ButtonBase)`
  color: var(--c-link);
  text-decoration: underline;
`;
const messages = defineMessages({
  title: {
    defaultMessage: 'Blocked Managers',
  },
  description: {
    defaultMessage: 'Manage the list of the managers you’ve blocked',
  },
  cta: {
    defaultMessage: 'Manage',
  },
});

export const BlockedUsers = () => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  return (
    <SettingsSection {...messages}>
      <div>
        <StyledButtonBase onClick={() => setOpenDialog(true)}>
          <BodyS bold>
            <FormattedMessage {...messages.cta} />
          </BodyS>
        </StyledButtonBase>
      </div>

      {!!openDialog && (
        <BlockedUsersDialog onClose={() => setOpenDialog(false)} />
      )}
    </SettingsSection>
  );
};
